import React, { type FunctionComponent } from 'react'
import { Button } from '@retailer-platform/shared-components'
import { type RadiumStyles } from 'ic-snacks'
import { BugIcon } from '@instacart/ids-core'
import { useDomainMessages } from '../../../../utils/domain/intl'

const buttonCss: RadiumStyles = {
  display: 'flex',
  flexWrap: 'nowrap',
  justifyContent: 'center',
  alignItems: 'center',
  margin: 'auto',
  marginRight: '10px',
  height: 40,
}

interface ReportAProblemButtonProps {
  onClick: () => void
  productCount: number | null
  disabled: boolean
}

const ReportAProblemButton: FunctionComponent<ReportAProblemButtonProps> = ({
  onClick,
  productCount,
  disabled,
}: ReportAProblemButtonProps) => {
  const i18n = useDomainMessages({
    reportAProblem: 'productsDomain.search.actions.reportAProblem',
  })
  return (
    <Button
      style={buttonCss}
      variant={'secondary'}
      onClick={onClick}
      disabled={disabled}
      title={i18n.reportAProblem}
    >
      {productCount} <BugIcon />
    </Button>
  )
}

export default ReportAProblemButton
